import { render, staticRenderFns } from "./unknown-words.vue?vue&type=template&id=12d7a653"
import script from "./unknown-words.vue?vue&type=script&lang=js"
export * from "./unknown-words.vue?vue&type=script&lang=js"
import style0 from "../../assets/sass/commponents/nlp.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./unknown-words.vue?vue&type=style&index=1&id=12d7a653&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports